var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_53_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_53_8",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_8",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_8",
    width: 24,
    height: 24,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAANJQTFRFAAAAEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajfEajffAIrKwAAAEZ0Uk5TAAEkKshDS/SvSvf8KT75/5kZ5vYcAsSEbuwOH/N/uBRhjVssEPgbNv6DhpypL6WVxjT90Cb6XpThCQjTMnfNvmwe7kkjWrNZIUgAAADySURBVHicbdHdSwJBFAXwczRlFRIMDEORFQRJJPFJEnuI/LcF8UUQIvGDSogUSRIWLPxIUcOZRdfVmXmZO/cHc+4whGaR/6Cm7yXXOvCTS2ggQHKmgUvR/4EKYW4vaKkQ4QrGGCpE/xDkSIUYpwgNoULiF8voQAVzAlx9wgGPyQ9Zp+YLXLPnQHrou+GrqDNfQLwLB7IyLfCN8MIQKe0j3Mm0Tfw91weSTRwhbyekKG9PN1yAwpusbkVM0Ky7ocjO/nSY9fCOUmv/nNn2FPDQsrdcDWcQydjT5KvngEc+i782RgrgqblZ31egAsp8sVx97AAQmToZC2MTGAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.736c9010fbbf88584b1683fb3e77eeba.svg";
export { ForwardRef as ReactComponent };